import { render, staticRenderFns } from "./EntityModerateNotificationItem.vue?vue&type=template&id=57c53956&"
import script from "./EntityModerateNotificationItem.vue?vue&type=script&lang=js&"
export * from "./EntityModerateNotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./EntityModerateNotificationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports